/* CodeKitab v2 — small storefront enhancements */
(function () {
  // 1) Tag combo variants on product pages: 2 books → "Popular", 3 books → "Best deal"
  function tagVariants(root) {
    var labels = (root || document).querySelectorAll('.variant-option__button-label, label[for^="variant"], .variant-option label');
    labels.forEach(function (el) {
      if (el.querySelector('.ck-vbadge')) return;
      var text = (el.textContent || '').trim();
      var plus = (text.match(/\+/g) || []).length;
      if (!plus) return;
      var b = document.createElement('span');
      b.className = 'ck-vbadge ' + (plus >= 2 ? 'ck-vbadge--best' : 'ck-vbadge--pop');
      b.textContent = plus >= 2 ? 'Best deal' : 'Popular';
      el.appendChild(b);
      el.classList.add('ck-has-vbadge');
    });
  }
  function run() { tagVariants(document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  // re-run after section re-renders (variant change morphs the picker)
  var mo = new MutationObserver(function () { clearTimeout(mo._t); mo._t = setTimeout(run, 120); });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
